import { Injectable } from '@angular/core';

import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BrowseInjectionLayerService {

  public currentLayer: BehaviorSubject<FeatureLayer> = new BehaviorSubject<FeatureLayer>(null);

  constructor() {
    var currentLayer = new FeatureLayer({
      url: "https://maps.texnet.beg.utexas.edu/arcgis/rest/services/injection/Injection/MapServer/1"
    });

    //We're not adding this layer to a view, so we need to tell it to go ahead and load whatever it needs.
    currentLayer.load();

    this.currentLayer.next(currentLayer);
  }
}
